import {getClientElementsInRelation, RELATION_ADOPTED_CHILD} from "../../element/relations";

const clickOutsideToCloseComponents = {};

/**
 *
 * @param id {string}
 * @param ignoredEls {[Node]}
 * @param close {function}
 */
function setClickOutsideToClose(id, ignoredEls, close) {
    if ('string' === typeof id
        && ignoredEls.every(el => el instanceof Node)
        && 'function' === typeof close
    ) {
        clickOutsideToCloseComponents[id] = [ignoredEls, close];
    } else {
        console.error('setClickOutsideToClose invalid arguments', id);
    }
}

function unsetClickOutsideToClose(id) {
    delete clickOutsideToCloseComponents[id];
}

function handleClickOutsideToClose(event, ignoredEls, close) {
    if (!document.body.contains(event.target)) {
        return;
    }

    if (ignoredEls.some(ignoredEl =>
            equalOrContains(ignoredEl, event.target)
            ||
            getAllAdoptedChildren(ignoredEl).some(adoptedChild =>
                equalOrContains(adoptedChild, event.target)
            )
        )) {
        return;
    }

    close();
}

function equalOrContains(el1, el2) {
    return el1 === el2 || el1.contains(el2);
}

function getAllAdoptedChildren(el) {
    const adoptedChildren = getClientElementsInRelation(RELATION_ADOPTED_CHILD, el);

    [].forEach.call(el.children, child => {
        adoptedChildren.push(...getAllAdoptedChildren(child));
    });

    return adoptedChildren;
}

document.addEventListener('mousedown', function (event) {
    for (let id in clickOutsideToCloseComponents) {
        if (clickOutsideToCloseComponents.hasOwnProperty(id)) {
            handleClickOutsideToClose(event, ...clickOutsideToCloseComponents[id]);
        }
    }
});


export {
    setClickOutsideToClose,
    unsetClickOutsideToClose
}
